import AccessLogs from "components/Collections/AccessLogs";
import Dashboard from "components/Collections/Dashboard";
import EmailTemplates from "components/Collections/EmailTemplates";
import Financials from "components/Collections/Financials";
import IpWhitelists from "components/Collections/IpWhitelists";
import Users from "components/Collections/Users";
import Analytics from "components/Collections/Analytics";
import Admins from "components/Collections/Admins";
import AccountSignups from "components/Collections/AccountSignups";
import StripeSubscriptions from "components/Collections/StripeSubscriptions";

const Collections = {
	AccountSignups: AccountSignups,
	AccessLogs: AccessLogs,
	Admins: Admins,
	Analytics: Analytics,
	Dashboard: Dashboard,
	EmailTemplates: EmailTemplates,
	Financials: Financials,
	IpWhitelists: IpWhitelists,
	StripeSubscriptions: StripeSubscriptions,
	Users: Users,

};

export default Collections;
